import { parseAsBoolean } from 'nuqs'

export const WorkBlockHistoryQueryMap = {
  work_block_history: parseAsBoolean.withDefault(false),
}
